import React from 'react';
import { string, number, shape } from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { ThemeProvider } from '@one-thd/sui-atomic-components';
import { getThemeByName } from '@thd-olt-component-react/stencil-themes';
import { bentoHeroDataModel } from './bentoHeroDataModel';
import { BentoHeroContainer } from './BentoHeroContainer';

const BentoHero = ({ componentId = '', componentClass = '', componentPosition = 1, livePreviewData = null }) => {
  const { data, loading, error } = useDataModel('component', {
    variables: {
      id: componentId,
      componentClass,
    }
  });

  const componentData = livePreviewData ? { ...livePreviewData, isLivePreviewData: true } : data;

  if (!componentData || loading || error) {
    return null;
  }

  return (
    <ImpressionProvider
      key={componentPosition}
      data={{
        id: componentId,
        component: BentoHero.displayName,
        name: BentoHero.displayName,
        type: 'content'
      }}
    >
      <ThemeProvider theme={getThemeByName(componentData?.component?.theme)}>
        <BentoHeroContainer data={componentData?.component || componentData} />
      </ThemeProvider>
    </ImpressionProvider>
  );
};

BentoHero.propTypes = {
  componentId: string,
  componentClass: string,
  componentPosition: number,
  livePreviewData: shape({})
};

BentoHero.displayName = 'BentoHero';

BentoHero.dataModel = bentoHeroDataModel;

export { BentoHero };
